const PRESENTATION_HOTKEYS = new Set([
  ' ',
  'arrowleft',
  'arrowright',
  'pageup',
  'pagedown',
  'home',
  'end',
  'b',
  'f',
  's',
]);

export function isInteractiveTarget(target: EventTarget | null): boolean {
  return target instanceof Element && Boolean(target.closest(
    'input, textarea, select, button, a, summary, video, iframe, [contenteditable="true"], [role="dialog"], .speaker-notes',
  ));
}

export function ignoresPresentationHotkeys(event: KeyboardEvent): boolean {
  return event.defaultPrevented || event.isComposing || event.ctrlKey || event.metaKey || event.altKey || isInteractiveTarget(event.target);
}

export function isRepeatedPresentationHotkey(
  event: Pick<KeyboardEvent, 'key' | 'repeat'>,
): boolean {
  return event.repeat && PRESENTATION_HOTKEYS.has(event.key.toLowerCase());
}
